<div class="order-details-page">
    <ngx-spinner name="orderDetailsSpinner" type="ball-spin-clockwise" bdColor="rgb(249, 249, 251)" size="medium" color="#ef870a" [fullScreen]="false" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 9999;"></ngx-spinner>

    <div class="back-link" (click)="goBack()">
        <img src="assets/images/back-arrow.svg">
        <span>Back to Orders</span>
    </div>

    <div *ngIf="!loading && order">
        <app-order-card
            [order]="order"
            [showDetails]="false"
            [showSkip]="true"
            [showCancel]="true"
            (actionCompleted)="loadOrderDetails(orderId)">
        </app-order-card>

        <div id="order-details-header" style="margin-bottom: 20px;">
            <div class="section-box-label">Delivery Address</div>
            <div class="address-box">
                <div style="display: flex; align-items: center; gap: 3rem; justify-content: space-between;">
                    <div class="address-content">
                        <span *ngIf="!enableEditAddress">{{order.address}}, {{order.zip}}, {{order.city}}</span>
                        <app-address-search *ngIf="enableEditAddress" (addressSelected)="onAddressSelected($event)"></app-address-search>
                    </div>
                    <ng-container *ngIf="isSubscriptionValidState(order)">
                        <div class="edit-address-button" *ngIf="!enableEditAddress" (click)="editAddress()">
                            <img src="assets/images/pencil.png" style="height: 14px;width: 14px;" alt="">
                            <span>Edit</span>
                        </div>
                        <div class="edit-address-button" *ngIf="enableEditAddress" (click)="closeEditAddress()">
                            <img src="assets/images/pencil.png" style="height: 14px;width: 14px;" alt="">
                            <span>Close</span>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>


        <div class="main-content-container" *ngIf="order_details.length > 0">
            <ng-container *ngFor="let item of order_details; index as j">
                <p-divider *ngIf="j != 0"></p-divider>
                <div class="week-summary" [id]="'week-' + item.week">
                    <div class="week-summary-header">
                        <div class="week-summary-title">
                            <span>{{j === 0 ? 'Current Week' : 'Upcoming Week'}}</span>
                        </div>
                        <div class="week-summary-price">
                            <p *ngIf="!hasDiscountForWeek(item.week)"><span class="discounted-price">  £{{getOriginalWeekPrice(item.week)}}</span></p>

                            <div class="price-stack" *ngIf="hasDiscountForWeek(item.week)">
                                <p style="margin:0;"><span class="full-price"> £{{getOriginalWeekPrice(item.week)}}</span><span class="discounted-price">  £{{getDiscountedWeekPrice(item.week)}}</span></p>
                                <p class="discount-percentage-box">Discount {{getDiscountAppliedWeekPercentage(item.week)}}%</p>
                            </div>
                        </div>
                    </div>
                    <!-- Meals Box -->
                    <div class="section-box-wrapper">
                        <div class="section-box-label">Meals</div>
                        <div class="section-box">
                            <div class="week-orders-details-container">
                                <div class="week-orders-details-box" *ngFor="let deliveryGroup of groupByDeliveryDate(item.details)">
                                    <div>
                                        <span>Delivery: <span class="delivery-date">{{deliveryGroup.delivery_date | date:'dd/MM/yyyy'}}</span></span>
                                    </div>
                                    <p-divider></p-divider>
                                    <div *ngFor="let ord of deliveryGroup.orders; index as i" [class]="i%2==0 ? 'meal-row-container back-grey' : 'meal-row-container'">
                                        <div class="meal-row" *ngIf="ord.meal_id">
                                            <span class="order-meal-name">{{ord.meal.name}}</span>
                                            <span class="order-meal-amount">x{{ord.count}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex; justify-content: flex-end; margin-top: 10px;" *ngIf="isSubscriptionValidState(order) && canEditWeek(order_details, item.week)">
                                <div class="edit-meals-button" (click)="openEditWeek(order.id, item.week)">
                                    <span>Edit</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Add-Ons Box -->
                    <div class="section-box-wrapper" *ngIf="hasAddonsForWeek(item) && item.week == 1 || item.week > 1">
                        <div class="section-box-label">Add-Ons</div>
                        <div class="section-box">
                            <div class="week-orders-details-container" *ngIf="hasAddonsForWeek(item)">
                                <div class="week-orders-details-box" *ngFor="let deliveryGroup of groupByDeliveryDate(item.details)">
                                    <ng-container *ngIf="getAddonsForDeliveryDate(item.week, deliveryGroup.delivery_date).length > 0">
                                        <div>
                                            <span>Delivery: <span class="delivery-date">{{deliveryGroup.delivery_date | date:'dd/MM/yyyy'}}</span></span>
                                        </div>
                                        <p-divider></p-divider>
                                        <div *ngFor="let ord of getAddonsForDeliveryDate(item.week, deliveryGroup.delivery_date); index as i" [class]="i%2==0 ? 'meal-row-container back-grey' : 'meal-row-container'">
                                            <div class="meal-row">
                                                <span class="order-meal-name">{{getAddonName(ord)}}</span>
                                                <span class="order-meal-amount">x{{ord.count}}</span>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div style="display: flex; justify-content: flex-end; margin-top: 10px;" *ngIf="isSubscriptionValidState(order) && canEditWeek(order_details, item.week)">
                                <div class="edit-meals-button" (click)="removeAddonsForWeek(order.id, item.week)" *ngIf="hasAddonsForWeek(item)">
                                    <span>Remove</span>
                                </div>
                                <div class="edit-meals-button" (click)="openEditWeek(order.id, item.week, 'addons')">
                                    <span *ngIf="hasAddonsForWeek(item)">Edit</span>
                                    <span *ngIf="!hasAddonsForWeek(item)">Buy</span>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </ng-container>
        </div>
    </div>
</div>

<!-- Remove Add-Ons Confirmation Dialog -->
<p-dialog [draggable]="false" [blockScroll]="true" [resizable]="false" [(visible)]="showRemoveAddonsConfirm" (onHide)="cancelRemoveAddons()">
    <div>
        <div class="popup-header">
            <span>Remove Add-Ons</span>
        </div>
        <p-divider></p-divider>
        <div style="padding: 1.5rem; text-align: center;">
            <p>You are about to remove all the add-ons from your future deliveries.</p>
            <p>Are you sure you want to continue?</p>
        </div>
        <div style="display: flex; justify-content: center; gap: 1rem; margin-top: 1rem; padding-bottom: 1rem;">
            <button class="cancel-btn" (click)="cancelRemoveAddons()">Cancel</button>
            <button class="confirm-btn" (click)="confirmRemoveAddons()">Confirm</button>
        </div>
    </div>
</p-dialog>
